import { routeExists } from "helpers/navigation";
import { observer } from "mobx-react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LicenseServerRoutes from "routes";
import { SignUpPage } from "./signUp";
import { SignInPage } from "./signIn";
import React from "react";

export const PublicView = observer(function PublicView() {
  const location = useLocation();

  return (
    <>
      <Routes>
        <Route path={LicenseServerRoutes.SignIn} element={<SignInPage />} />
        <Route path={LicenseServerRoutes.SignUp} element={<SignUpPage />} />

        {routeExists(location.pathname) ? (
          <Route
            path="*"
            element={
              <Navigate
                to={LicenseServerRoutes.SignIn}
                replace
                state={{
                  redirectUrl: location ? `${location?.pathname}${location?.search}` : "",
                }}
              />
            }
          />
        ) : (
          <Route path="*" element={<Navigate to={LicenseServerRoutes.SignIn} replace />} />
        )}
      </Routes>
    </>
  );
});
